<template>
  <v-app v-if="hasCompletedInitialLoad" :style="{background: $vuetify.theme.themes.light.background}">
    <app-bar v-if="userIsAuthenticated"/>
    <v-content>
      <div fill-height fluid>
        <router-view></router-view>
      </div>
    </v-content>
  </v-app>
</template>

<style lang="scss">
    @import '@/sass/variables.scss';
    @import '@/sass/main.scss';
</style>

<script>

import AppBar from './components/AppBar.vue'

export default {

    name: 'App',
    components: {
      AppBar
    },

    computed: {
      userIsAuthenticated() {
          return this.$store.getters['admins/user'] != null && this.$store.getters['admins/user'] != undefined;
      },

      hasCompletedInitialLoad() {
        return this.$store.getters['hasCompletedInitialLoad']
      }
    },
    
    watch: {
        '$route' (to) {
            document.title = to.meta.title || 'Adhera - Dashboard'
        }
    }
};
</script>
